import React, { useEffect } from 'react';
import Select from 'react-select';
import { useContext } from 'react';

const options = [
  { value: '2022', label: '2022-23' },
  { value: '2021', label: '2021-22' },
  { value: '2020', label: '2020-2021' },
];

export default function YearInput(props) {
  const handleChange = (newYear) => {
    props.handleChange(undefined, undefined, newYear.value)
  }
  // useEffect(() => {
  //   props.handleChange(undefined, undefined, options[0].value);
  // }, [])
  return (
    <div >
      <h1>Year</h1>
      <Select
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}